<!-- Tutor shell: menu column left, content card right; the learning sections
     of the AI configuration as tabs inside the card (like „Wissen"). -->
<app-tutor-menu>
  <nb-card class="learning-card">
    <nb-card-body>
      <nb-tabset *ngIf="ready && tabs.length" routeParam="tab" (changeTab)="onTabChange($event)">
        <nb-tab
          *ngFor="let tab of tabs; trackBy: trackTab"
          [tabId]="tab.key"
          [route]="tab.key"
          [tabTitle]="tab.titleKey | translate"
          [tabIcon]="tab.icon"
          [active]="tab.key === active"
          [lazyLoad]="true"
        >
          <ng-template nbTabTitle>
            <span class="tab-text" [alAnchor]="'tab.' + tab.key" [nbTooltip]="tab.hintKey | translate">{{ tab.titleKey | translate }}</span>
          </ng-template>
          <!-- Nur der offene Reiter baut seinen Inhalt: nb-tab hält projizierten
               Inhalt trotz lazyLoad am Leben, sonst liefen fünf
               KI-Konfigurationen mit je eigenen Anfragen gleichzeitig. -->
          <ng-container *ngIf="tab.key === active">
            <ng-container *ngComponentOutlet="aiSettings; injector: tab.injector"></ng-container>
          </ng-container>
        </nb-tab>
      </nb-tabset>
      <p *ngIf="ready && !tabs.length" class="empty-body">{{ "pages.tutors.noSettings" | translate }}</p>
      <nb-spinner *ngIf="!ready" status="basic"></nb-spinner>
    </nb-card-body>
  </nb-card>
</app-tutor-menu>
